import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { BasicModal } from "./BasicModal/BasicModal";
import { useNavigate } from "react-router-dom";

/**
 * Modal que se muestra cuando el usuario intenta acceder a una guía
 * que está en estado "próximamente disponible" (ej. Bali en revisión).
 */
const ComingSoonModal = ({ open, onClose, guideName }) => {
	const navigate = useNavigate();

	const handleExplorar = () => {
		onClose();
		navigate("/explorar");
	};

	return (
		<BasicModal
			width={400}
			showModal={open}
			handleClose={onClose}
		>
			<Box
				sx={{
					textAlign: "center",
					py: 1,
					px: 1,
				}}
			>
				<Box
					sx={{
						width: 56,
						height: 56,
						borderRadius: "50%",
						backgroundColor: "rgba(99, 102, 241, 0.12)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						mx: "auto",
						mb: 2,
					}}
				>
					<ScheduleIcon sx={{ fontSize: 32, color: "#6366F1" }} />
				</Box>
				<Typography
					variant="h6"
					sx={{
						fontWeight: 700,
						color: "#1a1a2e",
						mb: 0.5,
						fontSize: "1.25rem",
					}}
				>
					Próximamente disponible
				</Typography>
				<Typography
					variant="body2"
					sx={{
						color: "#64748B",
						mb: 2.5,
						fontSize: "0.938rem",
					}}
				>
					{guideName
						? `La guía "${guideName}" está en preparación y estará disponible pronto.`
						: "Esta guía está en preparación y estará disponible pronto."}
				</Typography>
				<Box sx={{ display: "flex", gap: 1.5, justifyContent: "center", flexWrap: "wrap" }}>
					<Button
						variant="outlined"
						onClick={onClose}
						sx={{
							textTransform: "none",
							fontWeight: 600,
							borderRadius: "10px",
							px: 2,
						}}
					>
						Cerrar
					</Button>
					<Button
						variant="contained"
						onClick={handleExplorar}
						sx={{
							textTransform: "none",
							fontWeight: 600,
							borderRadius: "10px",
							px: 2,
							background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
							"&:hover": {
								background: "linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
							},
						}}
					>
						Explorar guías
					</Button>
				</Box>
			</Box>
		</BasicModal>
	);
};

export default ComingSoonModal;
